import { EmployeesTeamsDocument, EmployeesTeamsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Team = EmployeesTeamsQuery['teams']['teams'][number]

export const useTeams = () => {
  const { loading, data } = useQuery(EmployeesTeamsDocument, {
    fetchPolicy: 'cache-first',
  })

  return {
    loading,
    teams: data?.teams.teams ?? [],
  }
}
